  
  let ENV = {
    apiUrl: process.env.REACT_APP_API_URL,
    basePath: process.env.REACT_APP_BASEPATH,
    mvitVantageEmailService: process.env.REACT_APP_MVIT_VANTAGE_EMAIL_SERVICE,
    contactTo: process.env.REACT_APP_CONTACT_TO,
    currentDomain: process.env.REACT_APP_DOMAIN,
  };

  export const config = { env: ENV, ...{
    emailApiUrl: "/api",
    lng: "en",
    version:"1.0",
    globalVar : {
      loaderColor: '#00A1DE',
    }
  }
  };
  
